import { render, staticRenderFns } from "./TeamAdmin.vue?vue&type=template&id=bbd83d78&"
import script from "./TeamAdmin.vue?vue&type=script&lang=js&"
export * from "./TeamAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports